import moment from 'moment';

export const trialDaysFinishDate = (hoursLeft?: number | null) => {
  return typeof hoursLeft !==  'number' ? null :
  moment().add(hoursLeft, 'hours').format('DD/MM/YYYY');
}
